// eslint-disable-next-line no-restricted-imports
import { useLocation } from '@remix-run/react'
import { invert, snakeCase } from 'lodash-es'
import { useMemo } from 'react'
import { convertQueryMapForMacaron } from './queryMap'

/**
 * レストランIDのバリデーション
 */
export function validateRestaurantId(param: string) {
  const regExp = new RegExp('[0-9]{6}')
  return regExp.test(param)
}

const convertQueryMapForRestaurant2: Record<string, string> = invert(convertQueryMapForMacaron)

/**
 * 現在のURLのクエリパラメータの文字列をRes2のクエリパラメータの形式に変換して返却する
 * @returns Res2用URLのクエリパラメータ文字列
 */
function toRes2QueryString(search: string) {
  const macaron = [...new URLSearchParams(search).entries()]
  const res2 = macaron.reduce((params, [key, value]) => {
    params.set(toRes2Key(key), value)
    return params
  }, new URLSearchParams())
  return res2.toString()
}

if (import.meta.vitest) {
  const { describe, test, expect } = import.meta.vitest
  describe('toRes2QueryString', () => {
    test('from queryMap', () => {
      const macaron = new URLSearchParams({
        visitorsCount: '2',
        childUses: '1',
        smokingAllowed: '1',
      })
      const res2 = new URLSearchParams(toRes2QueryString(macaron.toString()))
      expect(res2.get('visitorsCount')).toBeNull()
      expect(res2.get('num_guests')).toBe('2')
      expect(res2.get('childUses')).toBeNull()
      expect(res2.get('allow_children')).toBe('1')
      expect(res2.get('smokingAllowed')).toBeNull()
      expect(res2.get('smoking_permission')).toBe('1')
    })

    test('just to snakeCase', () => {
      const macaron = new URLSearchParams({
        visitDate: '2024-01-29',
        visitTime: '18:00',
      })
      const res2 = new URLSearchParams(toRes2QueryString(macaron.toString()))
      expect(res2.get('visitDate')).toBeNull()
      expect(res2.get('visit_date')).toBe('2024-01-29')
      expect(res2.get('visitTime')).toBeNull()
      expect(res2.get('visit_time')).toBe('18:00')
    })
  })
}

function toRes2Key(key: string) {
  return key in convertQueryMapForRestaurant2 ? convertQueryMapForRestaurant2[key] : snakeCase(key)
}

export function useRes2QueryString() {
  const { search } = useLocation()
  return useMemo(() => toRes2QueryString(search), [search])
}
